import getCachedResponse from './GetCachedResponse';
import removeCachedResponse from './RemoveCachedResponse';
import saveToCache from './SaveToCache';

export default {
  getCachedResponse,
  saveToCache,
  removeCachedResponse,
};
